export const getArrayItemIdFromFieldPath = (
  fieldPath: string,
  arrayKey: string
): string | undefined => {
  const segments = fieldPath.split('.')
  const keyIndex = segments.indexOf(arrayKey)

  return keyIndex >= 0 ? segments.at(keyIndex + 1) : undefined
}
